import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';

import { useContent } from '../../../../branding/content.context';
import CookieBanner from '../../../../components/CookieBanner';

export function OpenInviteLinkDisabled() {
    const theme = useTheme();
    const { openInviteLinkNotExist: DISABLED } = useContent();
    document.title = DISABLED.browserTitle;

    return (
        <>
            <div
                css={{
                    textAlign: 'center',
                    margin: `${theme.sizes.xxxLarge} 0`,
                }}
            >
                <Typography
                    testId="openInvite.submit.confirmation"
                    css={{
                        textAlign: 'center',
                        marginBottom: theme.sizes.large,
                    }}
                    variant="h3"
                >
                    {DISABLED.title}
                </Typography>
                <Typography
                    css={{
                        textAlign: 'center',
                    }}
                    variant="body1"
                >
                    {DISABLED.p1}
                </Typography>
            </div>
            <CookieBanner />
        </>
    );
}
